import {Layout} from '@ui-kitten/components';
import React from 'react';
import {StyleSheet} from 'react-native';
import {px} from '../../../utils';
import {TitleRow} from '../../components';
import TeacherRow from './TeacherRow';

const Teachers = ({teachers, onTeacherPress}) => {
  return (
    <Layout style={styles.container}>
      <TitleRow title="Teachers" type="secondary" />
      {teachers.map((teacher, index) => (
        <TeacherRow data={teacher} key={index} onPress={onTeacherPress} />
      ))}
    </Layout>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: px(10),
  },
});

export default Teachers;
